import React from "react";
import "./style.css";
import { useNavigate } from "react-router-dom";
import mixpanel from "mixpanel-browser";
import digitalImage from "../../../assets/images/digital-marketing_3141287.png"
import radioAdImage from "../../../assets/images/radio_ads.png"

const AdvertTypeModal = () => {

    const navigate = useNavigate()

    const routeHandler = (route) => {
        // register user event
        switch (route) {
          case "/book-campaign/":
            mixpanel.track("do_it_myself");
            break;
    
          case "/talk-with-an-expert":
            mixpanel.track("help_me_do_it");
            break;
    
          default:
            break;
        }
    
        navigate(route);
      };

      
  return (
    <div className="signup-modal-container ad-modal">
      <div>
        <div className="signup-modal-content">
          <div
            className="signup-modal-header"
            onClick={() => {
              // closeModal(false);
            }}
          >
            <svg
              width="19"
              height="17"
              viewBox="0 0 19 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_1558_2136)">
                <path
                  d="M14.25 4.25L4.75 12.75"
                  stroke="#0E0E2C"
                  stroke-width="1.375"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M4.75 4.25L14.25 12.75"
                  stroke="#0E0E2C"
                  stroke-width="1.375"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_1558_2136">
                  <rect width="19" height="17" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div className="signup-modal-body">
            <div className="signup-type">
              <div>
                <div className="first-type-container">
                  <div className="signup-type-info">
                    <img
                      src={radioAdImage}
                      alt="radio advertising"
                    />
                    <h5>Run Radio Ad</h5>
                    <p>
                      Broadcast your message to millions of listeners instantly.
                    </p>
                    <button 
                    onClick={() => routeHandler("/book-campaign/")}
                    className="signup-modal-btn">Get Started</button>
                  </div>
                </div>
              </div>
              <div>
                <div className="first-type-container">
                  <div className="signup-type-info">
                    <img
                      src={digitalImage}
                      alt="digital advertising"
                    />
                    <h5>Run Digital Ad</h5>
                    <p>
                      Reach your audience through targeted impressions and
                      clicks.
                    </p>
                    <button 
                    onClick={() => routeHandler("/book-campaign/v2")}
                    className="signup-modal-btn">Get Started</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvertTypeModal;
